/* @flow */
import React, { Component } from 'react'

import './VideoPlayer.css'

type Props = {
	videoId: string,
  isOpen: bool,
  closeVideo: Function,
}

type State = {
  video: Object,
}

export default class VideoPlayer extends Component<Props, State> {
  state = {
    video: {},
  }

  componentDidMount() {
    const { videoId } = this.props;
    const classThis = this;

    window._wq = window._wq || [];
    window._wq.push({
      id: videoId,
      options: {
        videoFoam: {
          minWidth: 200,
          maxWidth: 960
        },
      },
      onEmbedded: function(video) {
        classThis.setState({ video: video });

        video.bind('end', function() {
          classThis.closeVideo();
        });
      }
    });
  }

  componentDidUpdate(prevProps) {
    const { video } = this.state;
    if (!prevProps.isOpen && this.props.isOpen) {
      video.time(0);
      video.play();
    }
  }

  closeVideo = () => {
    const { closeVideo } = this.props;
    const { video } = this.state;

    video.pause()
    closeVideo();
  }

  handleVideoClick = (e) => {
    e.stopPropagation();
  }

  render() {
    const { videoId, isOpen } = this.props;

    return (
      <div className={`VideoPlayer--overlay ${isOpen ? 'VideoPlayer-open' : ''}`} onClick={this.closeVideo}>
        <div className={`VideoPlayer--video wistia_embed wistia_async_${videoId}`} onClick={this.handleVideoClick} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Widgets/VideoPlayer/VideoPlayer.js